import bnc from "bnc";

export const block       = new bnc("course-toc");

export const chapterEl   = block.el('chapter');
export const paragraphEl = block.el('paragraph');
export const lessonEl    = block.el('lesson');
export const sidebarEl   = block.el('sidebar');
